import React from 'react';

import { Link } from 'react-router-dom';

import { UiButton } from '../../../ui/ui-button';

import Message from '../../../widgets/legacy-message';

export const LegacyAutomationWarning = ({
  missingFieldIssue,
  variant,
  link,
  action,
  className,
}: {
  missingFieldIssue: { object: string; field: string; reason?: string };
  variant: 'employeeIssue' | 'automationIssue';
  link?: string;
  action?: () => void;
  className?: string;
}) => (
  <Message
    variant="error"
    canBeDismissed={false}
    className={`u-margin-bottom-xl u-margin-top ${className || ''}`}
  >
    {variant === 'employeeIssue' && link && (
      <div className="u-spread">
        <div>
          <Link to={link} target="_blank" rel="noopener noreferrer">
            Some {missingFieldIssue.object} are missing{' '}
            <span className="typo-bold">{missingFieldIssue.field}</span> and will not trigger
            automations.
          </Link>
        </div>
        <UiButton linkTo={link} target="_blank" rel="noopener noreferrer">
          View Issues
        </UiButton>
      </div>
    )}
    {variant === 'automationIssue' && (
      <div className="u-spread">
        <div>
          {missingFieldIssue.object} {missingFieldIssue.object.slice(-1) === 's' ? 'are' : 'is'}{' '}
          missing <span className="typo-bold">{missingFieldIssue.field}</span> needed for the{' '}
          {missingFieldIssue.reason}.
        </div>
        {action && <UiButton onClick={action}>Fix It</UiButton>}
      </div>
    )}
  </Message>
);
